var Storage = {
  session: {},
  local: {},
};

//Detect if in iframe
var webStorage = true;
try {
  webStorage = window.self === window.top;
} catch (e) {}

var local = {};
var session = {};

if (webStorage === true) {
  Storage.session.get = key => {
    var ret = sessionStorage[key];
    if (!ret || ret === "null") return null;
    return sessionStorage[key];
  };

  Storage.session.set = (key, data) => {
    sessionStorage.setItem(key, data);
  };

  Storage.session.clear = () => {
    sessionStorage.clear();
  };

  Storage.local.get = key => {
    var ret = localStorage[key];
    if (!ret || ret === "null") return null;
    return localStorage[key];
  };

  Storage.local.set = (key, data) => {
    localStorage.setItem(key, data);
  };

  Storage.local.clear = () => {
    localStorage.clear();
  };
} else {
  Storage.session.get = key => {
    return session[key];
  };

  Storage.session.set = (key, data) => {
    session[key] = data;
  };

  Storage.session.clear = () => {
    session = {};
  };

  Storage.local.get = key => {
    return local[key];
  };

  Storage.local.set = (key, data) => {
    local[key] = data;
  };

  Storage.local.clear = () => {
    local = {};
  };
}

export default Storage;






// WEBPACK FOOTER //
// ./src/misc/storage.js